import * as types from './types';

export const state = {
  list: [],
};

const sort = (list = []) => list.sort((a, b) => {
  if (!a.options_ids && b.options_ids) {
    return 1;
  }

  if (!b.options_ids && a.options_ids) {
    return -1;
  }

  return 0;
});

const find = (state, data, callback) => state.list.map(jump => {
  if (jump.id === data.id) {
    callback(jump);
  }

  return jump;
});

export const mutations = {
  [types.JUMP_ADD](state, { data }) {
    state.list.push(data);
    state.list = sort(state.list);
  },
  [types.JUMP_REMOVE](state, { data }) {
    state.list.splice(data.index, 1);
    state.list = sort(state.list);
  },
  [types.JUMP_CLEAR](state) {
    state.list = [];
  },
  [types.JUMP_SET_ACTIVE](state, { jumps }) {
    state.list = jumps;
    state.list = sort(state.list);
  },
  [types.JUMP_UPDATE_OPTION_ID](state, { data }) {
    find(state, data, (jump) => {
      jump.options_ids = data.options_ids;
    });
  },
  [types.JUMP_UPDATE_DESTINATION_STEP_ID](state, { data }) {
    find(state, data, (jump) => {
      jump.destination_step_id = data.destination_step_id;
    });
  },
  [types.JUMP_RESET_ACTIVE](state) {
    state.list = [];
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/jump/mutations.js
 **/